module.exports = __webpack_public_path__ + "static/media/icon_Que.3e1c6b48.png";